import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_FEATURE_FILTER = 'UPDATE_FEATURE_FILTER' as const;

export const updateFeatureFilter = (feature: string[]) => ({ data: { feature }, type: UPDATE_FEATURE_FILTER });

export type UpdateFeatureFilterResponseAction = DataAction<typeof UPDATE_FEATURE_FILTER, { feature: string[] }>;
